<ng-container *ngIf="options">
    <div>
        <!-- #createUpdateForm -->
        <aumico-form [options]="options" [delegate]="this" [data]="data.legalForm">
            <div extra-fields>
                <aum-select
                    [aumFormControl]="countryISO31661Alpha2CodesFormControl"
                    [options]="countries"
                    [multiple]="true"
                >
                    <aum-form-field-label>
                        {{ 'aumico_admin_countries_label' | i18next  }}
                    </aum-form-field-label>
                </aum-select>
            </div>
        </aumico-form>

        <div *ngIf="nameAlreadyExistsError" class="error">
            {{ 'aumico_settings_legalForm_form_name_already_exists_error' | i18next  }}
        </div>
    </div>
</ng-container>
